export const Constant = {
    pageLimit: 12,
};

export const CookieNames = {
    mostRecentProducts: "most-recent-products",
};
